module.exports = __webpack_public_path__ + "media/images/btn_history-19332639daf6e75aed37488822bcb7d4.gif";